import { SUPPORTED_BACKEND_LANGUAGES } from '@/constants'

const getBackendLanguageCode = (
    language: string | undefined,
    additionalBackendSupportedLanguages: readonly string[] = []
): string => {
    const baseLanguage = (language || 'en').split('-')[0].toLowerCase()
    const supportedLanguages = new Set([
        ...SUPPORTED_BACKEND_LANGUAGES,
        ...additionalBackendSupportedLanguages.map(languageCode => languageCode.toLowerCase()),
    ])

    return supportedLanguages.has(baseLanguage) ? baseLanguage : 'en'
}

export default getBackendLanguageCode